import { useEffect, useState } from "react";

import { Link, useNavigate, useParams } from "react-router-dom";

import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useTheme } from "@mui/material";
import Typography from "@mui/material/Typography";

import {
  StaticDocumentViewer,
  STATIC_DOC_PRIVACY,
  STATIC_DOC_TERMS,
} from "./StaticDocumentViewer/StaticDocumentViewer";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  height: "80%",
  maxWidth: "832px",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
};

export const Footer = () => {
  const [isTermAndConditionsOpen, setIsTermAndConditionsOpen] = useState(false);
  const [isPrivacyPolicyOpen, setIsPrivacyPolicyOpen] = useState(false);

  const theme = useTheme();

  const { termPolicy } = useParams();
  const navigate = useNavigate();

  const closeModal = () => {
    navigate("/");
    setIsPrivacyPolicyOpen(false);
    setIsTermAndConditionsOpen(false);
  };

  useEffect(() => {
    if (!termPolicy) return;
    setIsPrivacyPolicyOpen(termPolicy === "privacy-policy");
    setIsTermAndConditionsOpen(termPolicy === "terms-and-conditions");
  }, [termPolicy]);

  return (
    <>
      <Box
        sx={{
          alignItems: "center",
          height: "40px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Typography variant="body2">
          <Link
            to="/terms-and-conditions"
            style={{ color: theme.palette.primary.main }}
          >
            Terms and Conditions
          </Link>
          {" | "}
          <Link
            to="/privacy-policy"
            style={{ color: theme.palette.primary.main }}
          >
            Privacy Policy
          </Link>
        </Typography>
      </Box>

      <Modal
        onClose={closeModal}
        open={isTermAndConditionsOpen || isPrivacyPolicyOpen}
      >
        <Box sx={style}>
          {isTermAndConditionsOpen && (
            <StaticDocumentViewer name={STATIC_DOC_TERMS} />
          )}

          {isPrivacyPolicyOpen && (
            <StaticDocumentViewer name={STATIC_DOC_PRIVACY} />
          )}
        </Box>
      </Modal>
    </>
  );
};
